import { render, staticRenderFns } from "./ed-textarea-form.vue?vue&type=template&id=2fc0c7bd&scoped=true&"
import script from "./ed-textarea-form.ts?vue&type=script&lang=ts&"
export * from "./ed-textarea-form.ts?vue&type=script&lang=ts&"
import style0 from "./ed-textarea-form.scss?vue&type=style&index=0&id=2fc0c7bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0c7bd",
  null
  
)

export default component.exports